import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetPageBlockArgs {
  locale: string
}

export interface PageBlockDto {
  data: {
    id: number
    attributes: {
      button_over_the_mainvideo_1: string
      url_button_1: string
      button_over_the_mainvideo_2: string
      url_button_2: string
      text_over_the_mainvideo: string
      main_video: MediaObject
    }
  }
  meta: Record<string, unknown>
}

export const getPageBlock = async (
  client: AxiosInstance,
  { locale }: GetPageBlockArgs,
): Promise<PageBlockDto['data']['attributes']> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: [
      'button_over_the_mainvideo_1',
      'url_button_1',
      'button_over_the_mainvideo_2',
      'url_button_2',
      'text_over_the_mainvideo',
    ],
    populate: {
      main_video: { populate: '*' },
    },
  }
  return (await client.get<PageBlockDto>(path, { params })).data.data.attributes
}
